<ng-template #modal>
  <div class="modal-content">
    <div class="modal-header u-padding-vertical-0">
      <a>Novo Perfil</a>
      <mat-icon class="btn-fechar" (click)="fecharModal()">close</mat-icon>
    </div>

    <form [formGroup]="cadastraForm" (submit)="criarPerfil()" class="form__class">
      <div>
        <label class="form__div__label">Descrição do Perfil</label>
        <input class="form-control" name="descricao" formControlName="descricao" placeholder="Digite aqui">

        <div class="text-danger"
          *ngIf="cadastraForm.get('descricao')?.invalid && cadastraForm.get('descricao')?.touched">
          <div *ngIf="cadastraForm.get('descricao')?.errors?.required">*O campo é obrigatório</div>
        </div>
      </div>

      <div>
        <label class="form__div__label">Nome</label>
        <input class="form-control" name="nome" formControlName="nome" placeholder="Digite aqui">

        <div class="text-danger" *ngIf="cadastraForm.get('nome')?.invalid && cadastraForm.get('nome')?.touched">
          <div *ngIf="cadastraForm.get('nome')?.errors?.required">*O campo é obrigatório</div>
        </div>
      </div>

      <div *ngIf="!this.perfilInterno" class="form-grupo">
        <label class="form__div__label">Grupo Econômico</label>
        <select class="select__group" name="grupoEc" formControlName="grupoEc">
          <option [ngValue]="''">Selecionar</option>
          <option *ngFor="let grupo of gruposEconomicos.registros" [ngValue]="grupo.codigo">{{grupo.nome}}</option>
        </select>
        <div class="text-danger" *ngIf="cadastraForm.get('grupoEc')?.invalid && cadastraForm.get('grupoEc')?.touched">
          <div *ngIf="cadastraForm.get('grupoEc')?.errors?.required">*O grupo economico deve ser informado.</div>
        </div>
      </div>

      <div class="div-checkbox" *ngIf="this.token?.tipoUsuario == 'INT'">
        <input class="input-checkbox" type="checkbox" formControlName="perfilInterno"
          (change)="mostrarGruposEconomicos()">
        <label class="checkbox-label">Perfil Interno</label>
      </div>

      <button type="submit" [disabled]="cadastraForm.invalid" class="button-primary"> Criar
      </button>

    </form>
  </div>
</ng-template>